import { render, staticRenderFns } from "./ysgs.vue?vue&type=template&id=551e2008&scoped=true&"
import script from "./ysgs.vue?vue&type=script&lang=js&"
export * from "./ysgs.vue?vue&type=script&lang=js&"
import style0 from "./ysgs.vue?vue&type=style&index=0&id=551e2008&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551e2008",
  null
  
)

export default component.exports